<script lang="ts" context="module">
  /**
   * Props Convenience Type Export
   * ---------------------------------------------------------------------------
   */

  import type { ComponentProps } from "svelte";
  import IconButton from "./IconButton.svelte"; // self reference
  export type IconButtonProps = ComponentProps<IconButton>;

  /**
   * Types
   * ---------------------------------------------------------------------------
   */

  export type IconButtonSize = "large" | "medium" | "small";
</script>

<script lang="ts">
  /**
   * Imports
   * ---------------------------------------------------------------------------
   */

  import Icon, { type IconProps } from "@elements/Icon.svelte";
  import { createEventDispatcher } from "svelte";
  import { twMerge } from "tailwind-merge";

  /**
   * Props
   * ---------------------------------------------------------------------------
   */

  export let icon: IconProps;
  export let size: IconButtonSize = "medium";
  export let onClick: VoidFunction | null = null;

  /**
   * Style selection
   * ---------------------------------------------------------------------------
   */

  const sizeStyles: {
    [key in IconButtonSize]: string;
  } = {
    small: "w-6 h-6 min-w-6 min-h-6",
    medium: "w-8 h-8 min-w-8 min-h-8",
    large: "w-10 h-10 min-w-10 min-h-10",
  };
  const iconSize: {
    [key in IconButtonSize]: number;
  } = {
    small: 16,
    medium: 22,
    large: 28,
  };

  /**
   * Misc
   * ---------------------------------------------------------------------------
   */

  const dispatch = createEventDispatcher();
</script>

<!-- Template ----------------------------------------------------------------->

<button
  on:mouseover={() => dispatch("hover")}
  on:focus={() => dispatch("focus")}
  on:click={() => {
    if (onClick) {
      onClick();
    }
    dispatch("click");
  }}
  class={twMerge(
    "inline-flex justify-center items-center cursor-pointer",
    "rounded-full",
    "bg-white fill-black stroke-black",
    sizeStyles[size],
    $$props.class,
  )}
>
  <Icon name={icon.name} size={iconSize[size]} />
</button>
